import {Capacitor} from '@capacitor/core';
import {isMobileApp} from '@common/core/platform-detection';

const HAPTICS_PLUGIN_NAME = 'Haptics';

type HapticsModule = typeof import('@capacitor/haptics');

class AppHapticsManager {
  private modulePromise: Promise<HapticsModule> | null = null;

  isSupported(): boolean {
    return (
      isMobileApp() &&
      Capacitor.isNativePlatform() &&
      Capacitor.isPluginAvailable(HAPTICS_PLUGIN_NAME)
    );
  }

  async impactLight(): Promise<void> {
    if (!this.isSupported()) {
      return;
    }

    try {
      const {Haptics, ImpactStyle} = await this.loadModule();
      await Haptics.impact({style: ImpactStyle.Light});
    } catch (error) {
      console.warn('[AppHaptics] Failed to trigger light impact', error);
    }
  }

  async notifySuccess(): Promise<void> {
    if (!this.isSupported()) {
      return;
    }

    try {
      const {Haptics, NotificationType} = await this.loadModule();
      await Haptics.notification({type: NotificationType.Success});
    } catch (error) {
      console.warn('[AppHaptics] Failed to trigger success notification', error);
    }
  }

  private loadModule(): Promise<HapticsModule> {
    if (!this.modulePromise) {
      this.modulePromise = import('@capacitor/haptics');
    }

    return this.modulePromise;
  }
}

export const AppHaptics = new AppHapticsManager();
